// Shared site-wide constants for Reformity Inc.

export const COMPANY = {
    name: "Reformity Inc.",
    phone: "437-241-6287",
    phoneHref: "tel:4372416287",
    // Google Ads call-tracking line. Shown ONLY to visitors who arrived from a
    // Google Ads click (see hooks/usePhoneNumber) so those calls are
    // attributable to the campaign — a call to the main line above carries no
    // campaign signal and is invisible to Google forever. Both numbers ring the
    // same team. The main number stays canonical everywhere else: SEO copy,
    // JSON-LD, llms.txt, chat and the backend all keep using `phone`.
    phoneAds: "437-826-6190",
    phoneAdsHref: "tel:4378266190",
    email: "info@reformityinc.com",
    emailHref: "mailto:info@reformityinc.com",
    // Public-facing location only. The full head-office address lives in
    // BUSINESS_ADDRESS (seo-constants) — it feeds the LocalBusiness JSON-LD and
    // the Privacy Policy contact block, but is deliberately not shown in the
    // footer/contact cards (owner directive predates the 2026 relocation;
    // revisit if full NAP in the footer is wanted for local SEO).
    address: "North York, Ontario",
    hours: "Mon–Sat: 8:00 AM – 6:00 PM, Sun: Closed",
    tagline: "GTA's trusted exterior & interior contracting specialists.",
    yearFounded: 2018, // reconciled to match LocalBusiness JSON-LD foundingDate + About copy (was 2026)
};

export const SERVICES = [
    { label: "Fencing", path: "/services/fencing" },
    { label: "Interlocking & Paving", path: "/services/interlocking" },
    { label: "Decking", path: "/services/decking" },
    { label: "Concrete & Asphalt", path: "/services/concrete" },
    { label: "Landscaping", path: "/services/landscaping" },
    { label: "Interior Renovations", path: "/services/renovations" },
];

export const NAV_LINKS = [
    { label: "Gallery", path: "/gallery" },
    { label: "Blog", path: "/blog" },
    { label: "About", path: "/about" },
    { label: "Service Area", path: "/service-area" },
    { label: "Contact", path: "/contact" },
];

// Paste the real profile URL into `href` to show an icon in the footer. Entries
// left as "#" are hidden — a dead href="#" on every page is a crawl signal for
// nothing. Keep in sync with EXTERNAL_PROFILES in seo-constants.js, which
// feeds localBusinessSchema().sameAs.
export const SOCIAL_LINKS = [
    { label: "Facebook", href: "https://www.facebook.com/reformityinc", icon: "Facebook" },
    { label: "Instagram", href: "https://www.instagram.com/reformityinc", icon: "Instagram" },
    // The trailing "." is part of the real handle — without it YouTube 404s.
    { label: "YouTube", href: "https://www.youtube.com/@ReformityInc.", icon: "Youtube" },
    { label: "LinkedIn", href: "https://www.linkedin.com/company/reformity-inc/", icon: "Linkedin" },
].filter((s) => s.href && s.href !== "#");
